module.exports = __webpack_public_path__ + "img/map_mobile_5.3bef21c6.png";